import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { Layout } from '@/components/layout';
import { ProtectedRoute } from '@/components/auth';
import { Dashboard } from '@/components/dashboard';
import { Login } from '@/components/auth';
import { RegisterPage } from '@/components/auth/register/pages/RegisterPage';
import { SharedView, SharedAdd, SharedInfo } from '@/components/shared';
import { AppWrapper } from '@/components/common/AppWrapper';

export default function App() {
  const user = useAuthStore((state) => state.user);

  // Debug log to check if the app is rendering
  console.log('App rendering, user:', user);

  return (
    <AppWrapper>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/shared/view/:token" element={<SharedView />} />
          <Route path="/shared/add/:token" element={<SharedAdd />} />
          <Route path="/shared/info/:token" element={<SharedInfo />} />

          {/* Protected admin routes */}
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Login route */}
          <Route
            path="/login"
            element={
              user ? <Navigate to="/dashboard/tree" replace /> : <Login />
            }
          />

          {/* Home route */}
          <Route
            path="/"
            element={
              user ? (
                <Navigate to="/dashboard/tree" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />

          {/* Catch-all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AppWrapper>
  );
}